import {INavigationItem} from '../../types';
import NavListItem from '../NavListItem';
import s from './navList.module.css';
import {useEffect, useState} from "react";

interface INavListProps {
    navItems: INavigationItem[];
}

export default function NavList({navItems}: INavListProps) {
    //const userData = useUserStore((state) => state.userData);
    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        if (window.innerWidth < 720) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize)
    })

    useEffect(() => {
        handleResize();
    });


    return (
        <ul className={s.navList}>
            {navItems
                .filter((item) => item.visible)
                .map((item) => (
                    <NavListItem key={item.name} navItem={item}/>
                ))}
        </ul>
    );
}
